module.exports = __webpack_public_path__ + "static/media/tapeta_01.56b4fd49.jpg";